import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-age-crohn',
    templateUrl: './bar-chart-stable-unstable-age-crohn.component.html',
    styleUrls: ['./bar-chart-stable-unstable-age-crohn.component.css']
})

export class BarChartStableUnstableAgeCrohnComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  attivitaLieve = [];
  attivitaModerata = [];
  attivitaGrave = [];
  // other arrays
  stabiliLieve020 = 0;
  stabiliModerata020 = 0;
  stabiliGrave020 = 0;
  stabiliRemissione020 = 0;
  instabiliMiglLieve020 = 0;
  instabiliMiglModerata020 = 0;
  instabiliMiglGrave020 = 0;
  instabiliPegLieve020 = 0;
  instabiliPegModerata020 = 0;
  instabiliPegGrave020 = 0;
  instabiliMiglRemissione020 = 0;
  instabiliPegRemissione020 = 0;
  
  stabiliLieve2040 = 0;
  stabiliModerata2040 = 0;
  stabiliGrave2040 = 0;
  stabiliRemissione2040 = 0;
  instabiliMiglLieve2040 = 0;
  instabiliMiglModerata2040 = 0;
  instabiliMiglGrave2040 = 0;
  instabiliPegLieve2040 = 0;
  instabiliPegModerata2040 = 0;
  instabiliPegGrave2040 = 0;
  instabiliMiglRemissione2040 = 0;
  instabiliPegRemissione2040 = 0;
  
  stabiliLieve4060 = 0;
  stabiliModerata4060 = 0;
  stabiliGrave4060 = 0;
  stabiliRemissione4060 = 0;
  instabiliMiglLieve4060 = 0;
  instabiliMiglModerata4060 = 0;
  instabiliMiglGrave4060 = 0;
  instabiliPegLieve4060 = 0;
  instabiliPegModerata4060 = 0;
  instabiliPegGrave4060 = 0;
  instabiliMiglRemissione4060 = 0;
  instabiliPegRemissione4060 = 0;

  stabiliLieve60 = 0;
  stabiliModerata60 = 0;
  stabiliGrave60 = 0;
  stabiliRemissione60 = 0;
  instabiliMiglLieve60 = 0;
  instabiliMiglModerata60 = 0;
  instabiliMiglGrave60 = 0;
  instabiliPegLieve60 = 0;
  instabiliPegModerata60 = 0;
  instabiliPegGrave60 = 0;
  instabiliMiglRemissione60 = 0;
  instabiliPegRemissione60 = 0;
  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableCrohnAge: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['0-20 ANNI-STABILI','0-20 ANNI-IN MIGLIORAMENTO','0-20 ANNI-IN PEGGIORAMENTO',
  '20-40 ANNI-STABILI','20-40 ANNI-IN MIGLIORAMENTO','20-40 ANNI-IN PEGGIORAMENTO',
  '40-60 ANNI-STABILI','40-60 ANNI-IN MIGLIORAMENTO','40-60 ANNI-IN PEGGIORAMENTO',
  '60+ ANNI-STABILI','60+ ANNI-IN MIGLIORAMENTO','60+ ANNI-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.attivitaLieve,
      barThickness: 10,
      backgroundColor: ['#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', 
      '#ffd491','#ffd491', '#ffd491', '#ffd491'],
      hoverBackgroundColor: ['#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', 
      '#ef8800','#ef8800', '#ef8800', '#ef8800'],
      label: 'ATTIVITA LIEVE',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
        data: this.attivitaModerata,
        barThickness: 10,
        backgroundColor: ['#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', 
        '#ffb769','#ffb769', '#ffb769', '#ffb769'],
        hoverBackgroundColor: ['#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', 
        '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a'],
        label: 'ATTIVITA MODERATA',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
      {
        data: this.attivitaGrave,
        barThickness: 10,
        backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', 
        '#ff5232','#ff5232', '#ff5232', '#ff5232'],
        hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', 
        '#d11507','#d11507', '#d11507', '#d11507'],
        label: 'ATTIVITA GRAVE',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
    {
      data: this.remissione,
      barThickness: 10,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', 
      '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', 
      '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveAgeStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveAgeStableAndUnstable(){
    this.subscription = this.doctorService.getCrohnStableAndUnstableAge().subscribe( data => {
      let keys = Object.keys(data);
      //console.log("Keys: " + keys);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissione020'){
          this.stabiliRemissione020 = values[i];
        }
        else if (key === 'StabiliLieve020'){
          this.stabiliLieve020 = values[i];
        }
        else if (key === 'StabiliModerata020'){
          this.stabiliModerata020 = values[i];
        }
        else if (key === 'StabiliGrave020'){
          this.stabiliGrave020 = values[i];
        }
        else if (key === 'InstabiliMiglLieve020'){
          this.instabiliMiglLieve020 = values[i];
        }
        else if (key === 'InstabiliMiglModerata020'){
          this.instabiliMiglModerata020 = values[i];
        }
        else if (key === 'InstabiliMiglGrave020'){
          this.instabiliMiglGrave020 = values[i];
        }
        else if (key === 'InstabiliLieve020'){
          this.instabiliPegLieve020 = values[i];
        }
        else if (key === 'InstabiliPegModerata020'){
          this.instabiliPegModerata020 = values[i];
        }
        else if (key === 'InstabiliPegGrave020'){
          this.instabiliPegGrave020 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione020'){
          this.instabiliMiglRemissione020 = values[i];
        }
        else if (key === 'InstabiliPegRemissione020'){
          this.instabiliPegRemissione020 = values[i];
        }
        else if (key === 'StabiliRemissione2040'){
          this.stabiliRemissione2040 = values[i];
        }
        else if (key === 'StabiliLieve2040'){
          this.stabiliLieve2040 = values[i];
        }
        else if (key === 'StabiliModerata2040'){
          this.stabiliModerata2040 = values[i];
        }
        else if (key === 'StabiliGrave2040'){
          this.stabiliGrave2040 = values[i];
        }
        else if (key === 'InstabiliMiglLieve2040'){
          this.instabiliMiglLieve2040 = values[i];
        }
        else if (key === 'InstabiliMiglModerata2040'){
          this.instabiliMiglModerata2040 = values[i];
        }
        else if (key === 'InstabiliMiglGrave2040'){
          this.instabiliMiglGrave2040 = values[i];
        }
        else if (key === 'InstabiliPegLieve2040'){
          this.instabiliPegLieve2040 = values[i];
        }
        else if (key === 'InstabiliPegModerata2040'){
          this.instabiliPegModerata2040 = values[i];
        }
        else if (key === 'InstabiliPegGrave2040'){
          this.instabiliPegGrave2040 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione2040'){
          this.instabiliMiglRemissione2040 = values[i];
        }
        else if (key === 'InstabiliPegRemissione2040'){
          this.instabiliPegRemissione2040 = values[i];
        }
        else if (key === 'StabiliRemissione4060'){
          this.stabiliRemissione4060 = values[i];
        }
        else if (key === 'StabiliLieve4060'){
          this.stabiliLieve4060 = values[i];
        }
        else if (key === 'StabiliModerata4060'){
          this.stabiliModerata4060 = values[i];
        }
        else if (key === 'StabiliGrave4060'){
          this.stabiliGrave4060 = values[i];
        }
        else if (key === 'InstabiliMiglLieve4060'){
          this.instabiliMiglLieve4060 = values[i];
        }
        else if (key === 'InstabiliMiglModerata4060'){
          this.instabiliMiglModerata4060 = values[i];
        }
        else if (key === 'InstabiliMiglGrave4060'){
          this.instabiliMiglGrave4060 = values[i];
        }
        else if (key === 'InstabiliPegLieve4060'){
          this.instabiliPegLieve4060 = values[i];
        }
        else if (key === 'InstabiliPegModerata4060'){
          this.instabiliPegModerata4060 = values[i];
        }
        else if (key === 'InstabiliPegGrave4060'){
          this.instabiliPegGrave4060 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione4060'){
          this.instabiliMiglRemissione4060 = values[i];
        }
        else if (key === 'InstabiliPegRemissione4060'){
          this.instabiliPegRemissione4060 = values[i];
        }
        else if (key === 'StabiliRemissione60'){
          this.stabiliRemissione60 = values[i];
        }
        else if (key === 'StabiliLieve60'){
          this.stabiliLieve60 = values[i];
        }
        else if (key === 'StabiliModerata60'){
          this.stabiliModerata60 = values[i];
        }
        else if (key === 'StabiliGrave60'){
          this.stabiliGrave60 = values[i];
        }
        else if (key === 'InstabiliMiglLieve60'){
          this.instabiliMiglLieve60 = values[i];
        }
        else if (key === 'InstabiliMiglModerata60'){
          this.instabiliMiglModerata60 = values[i];
        }
        else if (key === 'InstabiliMiglGrave60'){
          this.instabiliMiglGrave60 = values[i];
        }
        else if (key === 'InstabiliPegLieve60'){
          this.instabiliPegLieve60 = values[i];
        }
        else if (key === 'InstabiliPegModerata60'){
          this.instabiliPegModerata60 = values[i];
        }
        else if (key === 'InstabiliPegGrave60'){
          this.instabiliPegGrave60 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione60'){
          this.instabiliMiglRemissione60 = values[i];
        }
        else if (key === 'InstabiliPegRemissione60'){
          this.instabiliPegRemissione60 = values[i];
        }
      }
      
      // riempio il vettore della categoria 'grave' in ordine stabili, miglioramento e peggioramento
      this.attivitaGrave.push(this.stabiliGrave020);
      this.attivitaGrave.push(this.instabiliMiglGrave020);
      this.attivitaGrave.push(this.instabiliPegGrave020);
      this.attivitaGrave.push(this.stabiliGrave2040);
      this.attivitaGrave.push(this.instabiliMiglGrave2040);
      this.attivitaGrave.push(this.instabiliPegGrave2040);
      this.attivitaGrave.push(this.stabiliGrave4060);
      this.attivitaGrave.push(this.instabiliMiglGrave4060);
      this.attivitaGrave.push(this.instabiliPegGrave4060);
      this.attivitaGrave.push(this.stabiliGrave60);
      this.attivitaGrave.push(this.instabiliMiglGrave60);
      this.attivitaGrave.push(this.instabiliPegGrave60);
      // riempio il vettore della categoria 'lieve' in ordine stabili, miglioramento e peggioramento
      this.attivitaLieve.push(this.stabiliLieve020);
      this.attivitaLieve.push(this.instabiliMiglLieve020);
      this.attivitaLieve.push(this.instabiliPegLieve020);
      this.attivitaLieve.push(this.stabiliLieve2040);
      this.attivitaLieve.push(this.instabiliMiglLieve2040);
      this.attivitaLieve.push(this.instabiliPegLieve2040);
      this.attivitaLieve.push(this.stabiliLieve4060);
      this.attivitaLieve.push(this.instabiliMiglLieve4060);
      this.attivitaLieve.push(this.instabiliPegLieve4060);
      this.attivitaLieve.push(this.stabiliLieve60);
      this.attivitaLieve.push(this.instabiliMiglLieve60);
      this.attivitaLieve.push(this.instabiliPegLieve60);
      // riempio il vettore della categoria 'moderata' in ordine stabili, miglioramento e peggioramento
      this.attivitaModerata.push(this.stabiliModerata020);
      this.attivitaModerata.push(this.instabiliMiglModerata020);
      this.attivitaModerata.push(this.instabiliPegModerata020);
      this.attivitaModerata.push(this.stabiliModerata2040);
      this.attivitaModerata.push(this.instabiliMiglModerata2040);
      this.attivitaModerata.push(this.instabiliPegModerata2040);
      this.attivitaModerata.push(this.stabiliModerata4060);
      this.attivitaModerata.push(this.instabiliMiglModerata4060);
      this.attivitaModerata.push(this.instabiliPegModerata4060);
      this.attivitaModerata.push(this.stabiliModerata60);
      this.attivitaModerata.push(this.instabiliMiglModerata60);
      this.attivitaModerata.push(this.instabiliPegModerata60);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissione020);
      this.remissione.push(this.instabiliMiglRemissione020);
      this.remissione.push(this.instabiliPegRemissione020);
      this.remissione.push(this.stabiliRemissione2040);
      this.remissione.push(this.instabiliMiglRemissione2040);
      this.remissione.push(this.instabiliPegRemissione2040);
      this.remissione.push(this.stabiliRemissione4060);
      this.remissione.push(this.instabiliMiglRemissione4060);
      this.remissione.push(this.instabiliPegRemissione4060);
      this.remissione.push(this.stabiliRemissione60);
      this.remissione.push(this.instabiliMiglRemissione60);
      this.remissione.push(this.instabiliPegRemissione60);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableCrohnAge') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableCrohnAge = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableCrohnAge.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableCrohnAge.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE' || 
              this.myChartStableUnstableCrohnAge.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA' ||
              this.myChartStableUnstableCrohnAge.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE' ||
              this.myChartStableUnstableCrohnAge.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'ATTIVITA LIEVE' || legendItem.text === 'ATTIVITA MODERATA'
            || legendItem.text === 'ATTIVITA GRAVE' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}